// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════
   ModalEvents — Premium Header & Layout
   ══════════════════════════════════════════════ */

.me-modal-container {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  width: 90vw;
  /* max-width: 1200px;
  max-height: 85vh; */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  height: 100%;
}

/* ── HEADER ── */
.me-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 22px;
  border-bottom: 1px solid #e2e8f0;
  background: rgba(248, 250, 252, 0.6);
  flex-shrink: 0;
  gap: 16px;
}

.me-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.me-device-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #0B2A5B;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(11, 42, 91, 0.25);
}

.me-device-info {
  min-width: 0;
}

.me-device-name {
  font-size: 17px;
  font-weight: 700;
  color: var(--third-color);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: -0.01em;
}

.me-device-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  font-size: 12px;
}

.me-ip-badge {
  font-family: 'SFMono-Regular', Consolas, monospace;
  background: rgba(226, 232, 240, 0.5);
  padding: 2px 8px;
  border-radius: 4px;
  color: #475569;
  font-size: 11px;
}

.me-dot-sep {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #cbd5e1;
  flex-shrink: 0;
}

.me-status-online {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #059669;
  font-weight: 500;
  font-size: 12px;
}

.me-pulse-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #10b981;
  animation: me-pulse 2s ease-in-out infinite;
}

@keyframes me-pulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.5;
    transform: scale(0.8);
  }
}

/* ── Offline status ── */
.me-status-offline {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #e11d48;
  font-weight: 500;
  font-size: 12px;
}

.me-pulse-dot-off {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #e11d48;
  opacity: 0.6;
}

/* ── HEADER RIGHT ── */
.me-header-right {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

/* ── TABS ── */
.me-tabs {
  display: flex;
  background: rgba(226, 232, 240, 0.5);
  padding: 3px;
  border-radius: 8px;
}

.me-tab {
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  background: transparent;
  color: #64748b;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.18s ease;
  white-space: nowrap;
}

.me-tab:hover {
  color: #1e293b;
  background: rgba(226, 232, 240, 0.7);
}

.me-tab-active {
  background: #0B2A5B !important;
  color: #fff !important;
  box-shadow: 0 2px 5px rgba(11, 42, 91, 0.25);
}

/* ── ACTIONS TAB ANIMATION ── */
.me-tab-animated-actions {
  position: relative;
  overflow: hidden;
  color: #0B2A5B;
  font-weight: 700;
  border: 1px solid rgba(11, 42, 91, 0.3);
  background: rgba(11, 42, 91, 0.05);
  transition: all 0.3s ease;
  animation: me-action-pulse 2s infinite;
}

.me-tab-animated-actions:hover {
  background: rgba(11, 42, 91, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(11, 42, 91, 0.15);
}

.me-tab-animated-actions.me-tab-active {
  background: #0B2A5B !important;
  color: #fff !important;
  border-color: #0B2A5B;
  box-shadow: 0 0 10px rgba(11, 42, 91, 0.4), 0 0 20px rgba(11, 42, 91, 0.2);
  animation: none;
}

/* Shiny sweep effect */
.me-tab-animated-actions::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 50%,
      rgba(255, 255, 255, 0) 100%);
  transform: skewX(-25deg);
  animation: me-shiny-sweep 3s infinite;
}

.me-tab-animated-actions.me-tab-active::after {
  background: linear-gradient(to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.3) 50%,
      rgba(255, 255, 255, 0) 100%);
}

@keyframes me-action-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(11, 42, 91, 0.4);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(11, 42, 91, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(11, 42, 91, 0);
  }
}

@keyframes me-shiny-sweep {
  0% {
    left: -100%;
  }

  20% {
    left: 200%;
  }

  100% {
    left: 200%;
  }
}

/* ── CLOSE BTN ── */
.me-close-btn {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #94a3b8;
  font-size: 16px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.15s ease;
}

.me-close-btn:hover {
  color: #e11d48;
  background: #fff1f2;
}

/* ── BODY ── */
.me-body {
  flex: 1 1;
  overflow: hidden;
  display: flex;
}

/* ── ACTIONS CONTENT ── */
.me-actions-content {
  width: 100%;
  padding: 20px;
  overflow-y: auto;
}

.me-actions-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.me-action-cell {
  width: 23%;
  min-width: 140px;
}

/* ── AlertsByHost Premium ── */
.mh-alerts-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #ffffff;
  /* border-radius: 12px; */
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.mh-alerts-header {
  display: flex;
  background: var(--third-color);
  border-bottom: 2px solid #e2e8f0;
  padding: 12px 1px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--white-color);
  position: sticky;
  top: 0;
  z-index: 10;
}

.mh-alert-hcell {
  display: flex;
  align-items: center;
  padding: 0 8px;
  cursor: pointer;
  transition: color 0.2s;
  justify-content: center;
}

/* .mh-alert-hcell:hover {
  color: #0B2A5B;
} */

.mh-alerts-body {
  flex: 1 1;
  overflow-y: auto;
  background: #ffffff;
}

.mh-alerts-body::-webkit-scrollbar {
  width: 6px;
}

.mh-alerts-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.mh-alert-row {
  display: flex;
  padding: 10px 16px;
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s;
  cursor: pointer;
  align-items: center;
  font-size: 12px;
  color: var(--txt-color);
  background: var(--white-color);
}

.mh-alert-row:hover {
  background: #f8fafc;
  border-left: 3px solid #0ea5e9;
  padding-left: 13px;
}

.mh-alert-row-active {
  background: rgba(11, 42, 91, 0.04) !important;
  border-left: 3px solid #0B2A5B;
  padding-left: 13px;
}

.mh-alert-cell {
  display: flex;
  align-items: center;
  padding: 0 8px;
  word-break: break-word;
  min-width: 0;
  justify-content: center;
}

.mh-alert-sev {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}

.mh-alert-sev-img {
  width: 20px;
  height: 20px;
}

.mh-alert-status {
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  text-transform: uppercase;
  white-space: nowrap;
}

.mh-status-resolved {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.mh-status-problem {
  background: #fff1f2;
  color: #e11d48;
  border: 1px solid #fecdd3;
}

.mh-radio-btn {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  flex-shrink: 0;
  transition: all 0.2s;
}

.mh-radio-btn-fill {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e1;
  transition: all 0.2s;
}

/* ── MenuAlert Expanded Premium ── */
.mh-expand-info {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  padding: 16px 20px;
  animation: slideDown 0.2s ease-out forwards;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mh-expand-grid {
  display: flex;
  gap: 24px;
}

.mh-expand-details {
  flex: 2 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  background: #ffffff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.mh-detail-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mh-det-label {
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.05em;
}

.mh-det-val {
  font-size: 13px;
  color: #334155;
  word-break: break-word;
}

.mh-ip-badge {
  font-family: 'SFMono-Regular', Consolas, monospace;
  background: rgba(226, 232, 240, 0.5);
  padding: 2px 6px;
  border-radius: 4px;
  color: #475569;
  font-size: 12px;
}

.mh-text-warn {
  color: #d97706;
  font-weight: 500;
}

.mh-expand-actions {
  flex: 1 1;
  background: #ffffff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-sizing: border-box;
}

.mh-actions-hdr {
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}

.mh-actions-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 10px;
  width: 100%;
}

.mh-actions-list>* {
  min-width: 0;
  width: 100%;
}

.mh-actions-list button {
  width: 100%;
  padding-left: 4px;
  padding-right: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── TERMINAL PRIMARY ACTION ── */
.me-action-cell-primary {
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.me-terminal-btn-wrapper {
  width: 100%;
  max-width: 450px;
}

.me-terminal-btn-wrapper .menuActionOption,
.me-terminal-btn-wrapper .compactAction {
  width: 100%;
  margin: 0;
  padding: 0;
}

.me-terminal-btn-wrapper button {
  width: 100% !important;
  padding: 16px 24px !important;
  font-size: 16px !important;
  font-weight: 800 !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background: linear-gradient(135deg, #0B2A5B, #1e4f9b) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 25px rgba(11, 42, 91, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.2) !important;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  overflow: hidden;
  animation: me-terminal-pulse 2s infinite;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 10px;
}

.me-terminal-btn-wrapper button::before {
  content: '⚡';
  font-size: 18px;
}

.me-terminal-btn-wrapper button:hover {
  transform: translateY(-3px) scale(1.02) !important;
  box-shadow: 0 12px 30px rgba(11, 42, 91, 0.6), inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  background: linear-gradient(135deg, #1e4f9b, #0B2A5B) !important;
}

.me-terminal-btn-wrapper button:active {
  transform: translateY(1px) scale(0.98) !important;
}

/* Shiny effect overlay for terminal button */
.me-terminal-btn-wrapper button::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%);
  transform: skewX(-25deg);
  animation: me-shiny-sweep-fast 3s infinite;
  pointer-events: none;
}

@keyframes me-terminal-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(11, 42, 91, 0.6), 0 8px 25px rgba(11, 42, 91, 0.4);
  }

  70% {
    box-shadow: 0 0 0 12px rgba(11, 42, 91, 0), 0 8px 25px rgba(11, 42, 91, 0.4);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(11, 42, 91, 0), 0 8px 25px rgba(11, 42, 91, 0.4);
  }
}

@keyframes me-shiny-sweep-fast {
  0% {
    left: -100%;
  }

  20% {
    left: 200%;
  }

  100% {
    left: 200%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/styles/modalEvents.css"],"names":[],"mappings":"AAAA;;mDAEmD;;AAEnD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX;qBACmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,oCAAoC;EACpC,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;;EAEE;;IAEE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uCAAuC;EACvC,kCAAkC;EAClC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,0EAA0E;EAC1E,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ;;;kCAGgC;EAChC,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE;;;kCAGgC;AAClC;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kDAAkD;EAClD,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,gEAAgE;EAChE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,iGAAiG;EACjG,eAAe;EACf,4DAA4D;EAC5D,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,kGAAkG;EAClG,gEAAgE;AAClE;;AAEA;EACE,iDAAiD;AACnD;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ;;;kCAGgC;EAChC,wBAAwB;EACxB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE;IACE,2EAA2E;EAC7E;;EAEA;IACE,4EAA4E;EAC9E;;EAEA;IACE,yEAAyE;EAC3E;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* ══════════════════════════════════════════════\n   ModalEvents — Premium Header & Layout\n   ══════════════════════════════════════════════ */\n\n.me-modal-container {\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);\n  width: 90vw;\n  /* max-width: 1200px;\n  max-height: 85vh; */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n}\n\n/* ── HEADER ── */\n.me-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 22px;\n  border-bottom: 1px solid #e2e8f0;\n  background: rgba(248, 250, 252, 0.6);\n  flex-shrink: 0;\n  gap: 16px;\n}\n\n.me-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.me-device-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #0B2A5B;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  flex-shrink: 0;\n  box-shadow: 0 2px 6px rgba(11, 42, 91, 0.25);\n}\n\n.me-device-info {\n  min-width: 0;\n}\n\n.me-device-name {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--third-color);\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  letter-spacing: -0.01em;\n}\n\n.me-device-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 2px;\n  font-size: 12px;\n}\n\n.me-ip-badge {\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  background: rgba(226, 232, 240, 0.5);\n  padding: 2px 8px;\n  border-radius: 4px;\n  color: #475569;\n  font-size: 11px;\n}\n\n.me-dot-sep {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: #cbd5e1;\n  flex-shrink: 0;\n}\n\n.me-status-online {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #059669;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.me-pulse-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #10b981;\n  animation: me-pulse 2s ease-in-out infinite;\n}\n\n@keyframes me-pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  50% {\n    opacity: 0.5;\n    transform: scale(0.8);\n  }\n}\n\n/* ── Offline status ── */\n.me-status-offline {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #e11d48;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.me-pulse-dot-off {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #e11d48;\n  opacity: 0.6;\n}\n\n/* ── HEADER RIGHT ── */\n.me-header-right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n/* ── TABS ── */\n.me-tabs {\n  display: flex;\n  background: rgba(226, 232, 240, 0.5);\n  padding: 3px;\n  border-radius: 8px;\n}\n\n.me-tab {\n  padding: 6px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  white-space: nowrap;\n}\n\n.me-tab:hover {\n  color: #1e293b;\n  background: rgba(226, 232, 240, 0.7);\n}\n\n.me-tab-active {\n  background: #0B2A5B !important;\n  color: #fff !important;\n  box-shadow: 0 2px 5px rgba(11, 42, 91, 0.25);\n}\n\n/* ── ACTIONS TAB ANIMATION ── */\n.me-tab-animated-actions {\n  position: relative;\n  overflow: hidden;\n  color: #0B2A5B;\n  font-weight: 700;\n  border: 1px solid rgba(11, 42, 91, 0.3);\n  background: rgba(11, 42, 91, 0.05);\n  transition: all 0.3s ease;\n  animation: me-action-pulse 2s infinite;\n}\n\n.me-tab-animated-actions:hover {\n  background: rgba(11, 42, 91, 0.1);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(11, 42, 91, 0.15);\n}\n\n.me-tab-animated-actions.me-tab-active {\n  background: #0B2A5B !important;\n  color: #fff !important;\n  border-color: #0B2A5B;\n  box-shadow: 0 0 10px rgba(11, 42, 91, 0.4), 0 0 20px rgba(11, 42, 91, 0.2);\n  animation: none;\n}\n\n/* Shiny sweep effect */\n.me-tab-animated-actions::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(to right,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.8) 50%,\n      rgba(255, 255, 255, 0) 100%);\n  transform: skewX(-25deg);\n  animation: me-shiny-sweep 3s infinite;\n}\n\n.me-tab-animated-actions.me-tab-active::after {\n  background: linear-gradient(to right,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.3) 50%,\n      rgba(255, 255, 255, 0) 100%);\n}\n\n@keyframes me-action-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(11, 42, 91, 0.4);\n  }\n\n  70% {\n    box-shadow: 0 0 0 6px rgba(11, 42, 91, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(11, 42, 91, 0);\n  }\n}\n\n@keyframes me-shiny-sweep {\n  0% {\n    left: -100%;\n  }\n\n  20% {\n    left: 200%;\n  }\n\n  100% {\n    left: 200%;\n  }\n}\n\n/* ── CLOSE BTN ── */\n.me-close-btn {\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 16px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.me-close-btn:hover {\n  color: #e11d48;\n  background: #fff1f2;\n}\n\n/* ── BODY ── */\n.me-body {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n}\n\n/* ── ACTIONS CONTENT ── */\n.me-actions-content {\n  width: 100%;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.me-actions-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.me-action-cell {\n  width: 23%;\n  min-width: 140px;\n}\n\n/* ── AlertsByHost Premium ── */\n.mh-alerts-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background: #ffffff;\n  /* border-radius: 12px; */\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n}\n\n.mh-alerts-header {\n  display: flex;\n  background: var(--third-color);\n  border-bottom: 2px solid #e2e8f0;\n  padding: 12px 1px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--white-color);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.mh-alert-hcell {\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  cursor: pointer;\n  transition: color 0.2s;\n  justify-content: center;\n}\n\n/* .mh-alert-hcell:hover {\n  color: #0B2A5B;\n} */\n\n.mh-alerts-body {\n  flex: 1;\n  overflow-y: auto;\n  background: #ffffff;\n}\n\n.mh-alerts-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.mh-alerts-body::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.mh-alert-row {\n  display: flex;\n  padding: 10px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s;\n  cursor: pointer;\n  align-items: center;\n  font-size: 12px;\n  color: var(--txt-color);\n  background: var(--white-color);\n}\n\n.mh-alert-row:hover {\n  background: #f8fafc;\n  border-left: 3px solid #0ea5e9;\n  padding-left: 13px;\n}\n\n.mh-alert-row-active {\n  background: rgba(11, 42, 91, 0.04) !important;\n  border-left: 3px solid #0B2A5B;\n  padding-left: 13px;\n}\n\n.mh-alert-cell {\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  word-break: break-word;\n  min-width: 0;\n  justify-content: center;\n}\n\n.mh-alert-sev {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n}\n\n.mh-alert-sev-img {\n  width: 20px;\n  height: 20px;\n}\n\n.mh-alert-status {\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.mh-status-resolved {\n  background: #ecfdf5;\n  color: #059669;\n  border: 1px solid #a7f3d0;\n}\n\n.mh-status-problem {\n  background: #fff1f2;\n  color: #e11d48;\n  border: 1px solid #fecdd3;\n}\n\n.mh-radio-btn {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid #cbd5e1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffffff;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\n.mh-radio-btn-fill {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #cbd5e1;\n  transition: all 0.2s;\n}\n\n/* ── MenuAlert Expanded Premium ── */\n.mh-expand-info {\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 16px 20px;\n  animation: slideDown 0.2s ease-out forwards;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.mh-expand-grid {\n  display: flex;\n  gap: 24px;\n}\n\n.mh-expand-details {\n  flex: 2;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n  background: #ffffff;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.mh-detail-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.mh-det-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: #94a3b8;\n  letter-spacing: 0.05em;\n}\n\n.mh-det-val {\n  font-size: 13px;\n  color: #334155;\n  word-break: break-word;\n}\n\n.mh-ip-badge {\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  background: rgba(226, 232, 240, 0.5);\n  padding: 2px 6px;\n  border-radius: 4px;\n  color: #475569;\n  font-size: 12px;\n}\n\n.mh-text-warn {\n  color: #d97706;\n  font-weight: 500;\n}\n\n.mh-expand-actions {\n  flex: 1;\n  background: #ffffff;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.mh-actions-hdr {\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: #64748b;\n  letter-spacing: 0.05em;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.mh-actions-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n  gap: 10px;\n  width: 100%;\n}\n\n.mh-actions-list>* {\n  min-width: 0;\n  width: 100%;\n}\n\n.mh-actions-list button {\n  width: 100%;\n  padding-left: 4px;\n  padding-right: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── TERMINAL PRIMARY ACTION ── */\n.me-action-cell-primary {\n  width: 100%;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n}\n\n.me-terminal-btn-wrapper {\n  width: 100%;\n  max-width: 450px;\n}\n\n.me-terminal-btn-wrapper .menuActionOption,\n.me-terminal-btn-wrapper .compactAction {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.me-terminal-btn-wrapper button {\n  width: 100% !important;\n  padding: 16px 24px !important;\n  font-size: 16px !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  background: linear-gradient(135deg, #0B2A5B, #1e4f9b) !important;\n  color: #fff !important;\n  border: none !important;\n  border-radius: 12px !important;\n  box-shadow: 0 8px 25px rgba(11, 42, 91, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.2) !important;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  position: relative;\n  overflow: hidden;\n  animation: me-terminal-pulse 2s infinite;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 10px;\n}\n\n.me-terminal-btn-wrapper button::before {\n  content: '⚡';\n  font-size: 18px;\n}\n\n.me-terminal-btn-wrapper button:hover {\n  transform: translateY(-3px) scale(1.02) !important;\n  box-shadow: 0 12px 30px rgba(11, 42, 91, 0.6), inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;\n  background: linear-gradient(135deg, #1e4f9b, #0B2A5B) !important;\n}\n\n.me-terminal-btn-wrapper button:active {\n  transform: translateY(1px) scale(0.98) !important;\n}\n\n/* Shiny effect overlay for terminal button */\n.me-terminal-btn-wrapper button::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(to right,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.5) 50%,\n      rgba(255, 255, 255, 0) 100%);\n  transform: skewX(-25deg);\n  animation: me-shiny-sweep-fast 3s infinite;\n  pointer-events: none;\n}\n\n@keyframes me-terminal-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(11, 42, 91, 0.6), 0 8px 25px rgba(11, 42, 91, 0.4);\n  }\n\n  70% {\n    box-shadow: 0 0 0 12px rgba(11, 42, 91, 0), 0 8px 25px rgba(11, 42, 91, 0.4);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(11, 42, 91, 0), 0 8px 25px rgba(11, 42, 91, 0.4);\n  }\n}\n\n@keyframes me-shiny-sweep-fast {\n  0% {\n    left: -100%;\n  }\n\n  20% {\n    left: 200%;\n  }\n\n  100% {\n    left: 200%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
